import { TopNav } from './TopNav';
import { BottomNav } from './BottomNav';
import { PageWrapper } from './PageWrapper';

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <TopNav />
      <PageWrapper>
        {children}
      </PageWrapper>
      <BottomNav />
    </div>
  );
}